<template>
  <div class="p-6 bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen">
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-2xl font-bold text-gray-800 inline-block transition-all duration-500">
        <span class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 hover:animate-pulse">
          {{ id ? 'ویرایش محصول' : 'ایجاد محصول جدید' }}
        </span>
      </h1>
      <button
          v-if="!popUp && user.user_type != 'ma'"
          @click="reset"
          class="p-2 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300 hover:bg-gray-50 transform hover:scale-105"
          title="جدید"
      >
        جدید
      </button>

      <button
          v-if="!popUp && user.user_type == 'ma'"
          @click="goBack"
          class="p-2 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300 hover:bg-gray-50 transform hover:scale-105"
          title="بازگشت به لیست"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
        </svg>
      </button>
    </div>

    <div v-if="loading && id" class="flex justify-center items-center h-64">
      <svg class="animate-spin h-12 w-12 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    </div>

    <div v-else class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl shadow-sm border border-gray-100 p-6">

      <form @submit.prevent="" enctype="multipart/form-data">
        <div class="mb-8" v-show="!popUp">
          <h2 class="text-lg font-medium text-gray-800 mb-4 border-b pb-2 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-2 text-pink-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            تصاویر محصول
          </h2>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">تصویر اصلی</label>
              <div class="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                <div class="space-y-1 text-center">
                  <div class="flex text-sm text-gray-600">
                    <label class="relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none">
                      <span>آپلود تصویر</span>
                      <input type="file" class="sr-only" @change="handleImageUpload" accept="image/*">
                    </label>
                    <p class="pl-1">یا کشیدن و رها کردن</p>
                  </div>
                  <p class="text-xs text-gray-500">PNG, JPG, GIF تا 10MB</p>
                </div>
              </div>

              <div class="mt-2" v-if="form.image">
                <img :src="image_source(form.image)" class="h-32 w-32 object-cover rounded-md border">
              </div>
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">گالری تصاویر</label>
              <div class="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                <div class="space-y-1 text-center">
                  <div class="flex text-sm text-gray-600">
                    <label class="relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none">
                      <span>آپلود چند تصویر</span>
                      <input type="file" class="sr-only" multiple @change="handleGalleryUpload" accept="image/*">
                    </label>
                  </div>
                </div>
              </div>
              <div v-if="form.images && form.images.length > 0" class="mt-2 flex flex-wrap gap-2">
                <div v-for="(img, index) in form.images" :key="index" class="relative">
                  <img :src="image_source(img.preview)" class="h-20 w-20 object-cover rounded-md border">
                  <button
                      @click="removeGalleryImage(index)"
                      class="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition duration-200"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-8">
          <h2 class="text-lg font-medium text-gray-800 mb-4 border-b pb-2 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-2 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            اطلاعات پایه
          </h2>
          <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div class="col-span-4">
              <label for="name" class="block text-sm font-medium text-gray-700 mb-1 flex items-center">
                <span class="text-red-500 ml-1">*</span>
                نام محصول
              </label>

              <input
                  v-model="form.name"
                  type="text"
                  id="name"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                  :class="{'border-red-300': errors.name}"
              >
              <p v-if="errors.name" class="mt-1 text-sm text-red-600">{{ errors.name }}</p>
            </div>

            <div class="col-span-2">
              <label for="sku" class="block text-sm font-medium text-gray-700 mb-1 flex items-center">
                <span class="text-red-500 ml-1">*</span>
                کد SKU
              </label>
              <div class="relative">
                <input
                    v-model="form.sixteen_digit_code"
                    type="text"
                    id="sku"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                    :class="{'border-red-300': errors.sixteen_digit_code}"
                >
              </div>
              <p v-if="errors.sixteen_digit_code" class="mt-1 text-sm text-red-600">{{ errors.sixteen_digit_code }}</p>
            </div>
            <div class="col-span-2">
              <label for="product_type" class="block text-sm font-medium text-gray-700 mb-1">نوع محصول</label>
              <select
                  v-model="form.product_type"
                  id="product_type"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                  :class="{'border-red-300': errors.product_type}"
              >
                <option value="">انتخاب کنید</option>
                <option value="simple">ساده (بدون متغیر)</option>
                <option value="variable">دارای متغیر</option>
              </select>
            </div>
            <div class="col-span-2">
              <label for="status" class="block text-sm font-medium text-gray-700 mb-1 flex items-center">
                <span class="text-red-500 ml-1">*</span>
                وضعیت
              </label>
              <select
                  v-model="form.status"
                  id="status"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                  :class="{'border-red-300': errors.status}"
              >
                <option value="draft">پیش نویس</option>
                <option value="pending">در انتظار تایید</option>
                <option value="publish">منتشر شده</option>
              </select>
              <p v-if="errors.status" class="mt-1 text-sm text-red-600">{{ errors.status }}</p>
            </div>
            <div class="col-span-2">
              <label for="content_status" class="block text-sm font-medium text-gray-700 mb-1 flex items-center">
                <span class="text-red-500 ml-1">*</span>
                وضعیت محتوا
              </label>
              <select
                  v-model="form.content_status"
                  id="content_status"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                  :class="{'border-red-300': errors.content_status}"
              >
                <option value="waiting">در انتظار تولید محتوا</option>
                <option value="done_pending">تکمیل شده - در انتظار تأیید</option>
                <option value="approved">تأیید شده</option>
              </select>
              <p v-if="errors.status" class="mt-1 text-sm text-red-600">{{ errors.content_status }}</p>
            </div>



            <div class="md:col-span-4">
              <label for="explanation" class="block text-sm font-medium text-gray-700 mb-1">توضیحات</label>
              <quill-editor
                  id="explanation"
                  v-model="form.explanation"
                  :options="editorOptions"
                  style="min-height: 100px"
              />

              <p v-if="errors.explanation" class="mt-1 text-sm text-red-600">{{ errors.explanation }}</p>
            </div>
            <div class="md:col-span-2">
              <label for="summary_explanation" class="block text-sm font-medium text-gray-700 mb-1"> توضیحات کوتاه</label>
              <quill-editor
                  id="summary_explanation"
                  v-model="form.summary_explanation"
                  :options="editorOptions"
                  style="min-height: 100px"
              />
              <p v-if="errors.summary_explanation" class="mt-1 text-sm text-red-600">{{ errors.summary_explanation }}</p>
            </div>
            <div class="md:col-span-2">
              <label for="how_to_use" class="block text-sm font-medium text-gray-700 mb-1">نحوه مصرف</label>
              <quill-editor
                  id="how_to_use"
                  v-model="form.how_to_use"
                  :options="editorOptions"
                  style="min-height: 100px"
              />

              <p v-if="errors.how_to_use" class="mt-1 text-sm text-red-600">{{ errors.how_to_use }}</p>
            </div>
            <div class="md:col-span-4">
              <label for="explanation" class="block text-sm font-medium text-gray-700 mb-1">سوالات متداول</label>
              <quill-editor
                  id="faq"
                  v-model="form.faq"
                  :options="editorOptions"
                  style="min-height: 100px"
              />

              <p v-if="errors.faq" class="mt-1 text-sm text-red-600">{{ errors.faq }}</p>
            </div>
            <div class="md:col-span-4">
              <label for="explanation" class="block text-sm font-medium text-gray-700 mb-1">بلاگ</label>
              <quill-editor
                  id="blog"
                  v-model="form.blog"
                  :options="editorOptions"
                  style="min-height: 100px"
              />

              <p v-if="errors.blog" class="mt-1 text-sm text-red-600">{{ errors.blog }}</p>
            </div>
          </div>
        </div>

        <div class="mb-8">
          <h2 class="text-lg font-medium text-gray-800 mb-4 border-b pb-2 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-2 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            قیمت گذاری
          </h2>

          <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div v-if="form.product_type != 'variable'">
              <label for="currency" class="block text-sm font-medium text-gray-700 mb-1 flex items-center">
                نوع قیمت گذاری
              </label>
              <div>
                <select
                    id="legend_pricing"
                    v-model="form.legend_pricing"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                >
                  <option value="false">قیمت گذاری ساده</option>
                  <option value="true">قیمت گذاری پیشرفته</option>
                </select>

              </div>
            </div>
            <div>
              <label for="currency" class="block text-sm font-medium text-gray-700 mb-1 flex items-center">
                نوع ارز
              </label>
              <select
                  v-model="form.currency"
                  id="currency"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                  :class="{'border-red-300': errors.currency}"
              >
                <option v-for="currency in currencies" :key="currency.id" :value="currency.id">
                  {{ currency.name }}
                </option>
              </select>
              <p v-if="errors.currency" class="mt-1 text-sm text-red-600">{{ errors.currency }}</p>
            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-6 gap-6 mt-3" v-if="form.product_type != 'variable'">
            <div class="md:col-span-3" v-if="form.legend_pricing == 'false'">
              <label for="regular_price" class="block text-sm font-medium text-gray-700 mb-1 flex items-center">
                <span class="text-red-500 ml-1">*</span>
                قیمت اصلی
              </label>
              <div class="relative rounded-md shadow-sm">
                <input
                    v-model.number="form.regular_price"
                    type="number"
                    id="regular_price"
                    min="0"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 pr-10"

                    :class="{'border-red-300': errors.regular_price}"
                >
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span class="text-gray-500 text-sm">تومان</span>
                </div>
              </div>
              <p v-if="errors.regular_price" class="mt-1 text-sm text-red-600">{{ errors.regular_price }}</p>
            </div>

            <div class="md:col-span-3" v-if="form.legend_pricing == 'false'">
              <label for="price" class="block text-sm font-medium text-gray-700 mb-1 flex items-center">
                <span class="text-red-500 ml-1">*</span>
                قیمت فروش
              </label>
              <div class="relative rounded-md shadow-sm">
                <input
                    v-model.number="form.price"
                    type="number"
                    id="price"
                    min="0"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 pr-10"
                    :class="{'border-red-300': errors.price}"
                >
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span class="text-gray-500 text-sm">تومان</span>
                </div>
              </div>
              <p v-if="errors.price" class="mt-1 text-sm text-red-600">{{ errors.price }}</p>
            </div>
            <div class="md:col-span-1" v-if="form.legend_pricing == 'true'">
              <label for="base_price" class="block text-[10px] font-medium text-gray-700 mb-1 flex items-center">
                <span class="text-red-500 ml-1">*</span>
                قیمت پایه
                (× {{current_currency.exchange_rate_to_toman | toMoney}})
              </label>
              <div class="relative rounded-md shadow-sm">
                <input
                    v-model.number="form.base_price"
                    type="number"
                    id="base_price"
                    min="0"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 pr-10"
                    :class="{'border-red-300': errors.base_price}"
                >
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span class="text-gray-500 text-[8px]">{{current_currency.name}}</span>
                </div>
              </div>
              <label for="base_price" class="block text-[8px] mb-1 pt-2 flex items-center">
                <span class="text-blue-100 bg-blue-700 rounded-xl  mt-7 px-[5px]">!</span>
                برابر با
                ( {{base_price_with_rate | toMoney}} تومان)
              </label>

              <p v-if="errors.base_price" class="mt-1 text-sm text-red-600">{{ errors.base_price }}</p>
            </div>
            <div class="md:col-span-1" v-if="form.legend_pricing == 'true'">
              <label for="profit_type" class="block text-[10px] font-medium text-gray-700 mb-1 flex items-center">
                <span class="text-red-500 ml-1">*</span>
                نوع حاشیه سود
              </label>
              <div>
                <select
                    id="profit_type"
                    v-model="form.profit_type"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                >
                  <option value="percent">درصد</option>
                  <option value="amount">مبلغ</option>
                </select>

              </div>
            </div>
            <div class="md:col-span-1" v-if="form.legend_pricing == 'true'">
              <label for="profit_amount" class="block text-[10px] font-medium text-gray-700 mb-1 flex items-center">
                <span class="text-red-500 ml-1">*</span>
                حاشیه سود
                <span class="text-[7px]">برابر</span>
                {{profit_sum | toMoney}}
                <span class="text-[7px]">تومان</span>
              </label>
              <div class="relative rounded-md shadow-sm">
                <input
                    v-model.number="form.profit_margin"
                    type="number"
                    id="profit_amount"
                    min="0"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 pr-10"
                    :class="{'border-red-300': errors.profit_margin}"
                >
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span class="text-gray-500 text-sm" v-if="form.profit_type == 'amount'">تومان</span>
                  <span class="text-gray-500 text-sm" v-else>درصد</span>
                </div>
              </div>
              <label for="base_price" class="block text-[8px] mb-1 pt-2 flex items-center">
                <span class="text-blue-100 bg-blue-700 rounded-xl  mt-7 px-[5px]">!</span>
                مبلغ با حاشیه سود
                ( {{(profit_sum + base_price_with_rate) | toMoney}} تومان)
              </label>

              <p v-if="errors.profit_margin" class="mt-1 text-sm text-red-600">{{ errors.profit_margin }}</p>
            </div>
            <div class="md:col-span-1" v-if="form.legend_pricing == 'true'">
              <label for="profit_type" class="block text-[10px] font-medium text-gray-700 mb-1 flex items-center">
                <span class="text-red-500 ml-1">*</span>
                نوع تخفیف
              </label>
              <div>
                <select
                    id="discount_type"
                    v-model="form.discount_type"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                >
                  <option value="percent">درصد</option>
                  <option value="amount">مبلغ</option>
                </select>

              </div>
            </div>
            <div class="md:col-span-1" v-if="form.legend_pricing == 'true'">
              <label for="discount_amount" class="block text-[10px] font-medium text-gray-700 mb-1 flex items-center">
                <span class="text-red-500 ml-1">*</span>
                مقدار تخفیف
                {{discount_sum | toMoney}}
                <span class="text-[7px]">تومان</span>

              </label>
              <div class="relative rounded-md shadow-sm">
                <input
                    v-model.number="form.discount_margin"
                    type="number"
                    id="discount_amount"
                    min="0"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 pr-10"
                    :class="{'border-red-300': errors.discount_margin}"
                >
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span class="text-gray-500 text-sm" v-if="form.discount_type == 'amount'">تومان</span>
                  <span class="text-gray-500 text-sm" v-else>درصد</span>
                </div>
              </div>
              <p v-if="errors.discount_margin" class="mt-1 text-sm text-red-600">{{ errors.discount_amount }}</p>
            </div>
            <div class="md:col-span-1" v-if="form.legend_pricing == 'true'">
              <label for="final_amount" class="block text-[10px] font-medium text-gray-700 mb-1 flex items-center">
                <span class="text-red-500 ml-1"></span>
                قیمت نهایی فروش
              </label>
              <div class="relative rounded-md shadow-sm">
                <input
                    disabled
                    v-model.number="final_amount"
                    type="number"
                    id="final_amount"
                    min="0"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 pr-10"
                >
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span class="text-gray-500 text-sm" >تومان</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-8" v-if="form.product_type != 'variable'">
          <h2 class="text-lg font-medium text-gray-800 mb-4 border-b pb-2 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-2 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
            </svg>
            موجودی
          </h2>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="md:col-span-1">
              <label class="block text-sm font-medium text-gray-700 mb-1">موجودی  {{form.packing_inventory.name}}</label>
              <input
                  type="number"
                  v-model="form.packing_inventory.inventory"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 pr-10"
              />
            </div>
            <div class="md:col-span-1">
              <label class="block text-sm font-medium text-gray-700 mb-1">حداقل موجودی  {{form.packing_inventory.name}}</label>
              <input
                  type="number"
                  v-model="form.packing_inventory.minimum_inventory"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 pr-10"
              />
            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4" v-for="(store, index) in form.inventories_in_stores">
            <div class="md:col-span-1" >
              <label v-if="store.name !== 'new'" class="block text-sm font-medium text-gray-700 mb-1">موجودی انبار  {{store.name}}</label>
              <label v-else class="block text-sm font-medium text-gray-700 mb-1">
                <button @click.prevent="removeStore(index)" class="delete-btn ml-2 text-gray-500 hover:text-red-500">
                  <i class="fas fa-trash"></i>
                </button>

                انبار جدید </label>
              <store-select :not_in="store_with_inventory_ids" v-if="store.name === 'new'" v-model="store.store"></store-select>
              <input
                  v-if="store.name !== 'new'"
                  type="number"
                  v-model="store.inventory"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 pr-10"
              />
            </div>
            <div class="md:col-span-1" v-if="store.name == 'new'">
              <label  class="block text-sm font-medium text-gray-700 mb-1">
                موجودی انبار جدید
              </label>
              <input
                  type="number"
                  v-model="store.inventory"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 pr-10"
              />
            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4" v-if="this.stores && this.store_with_inventory_ids">
            <div class="md:col-span-1 pt-6" v-if="!has_new_store">
              <button
                  @click="addStoreInventory"
                  type="button"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm items-center
                    focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                    transition duration-200 bg-blue-500 text-white font-medium pr-10"
              >
                <span class="text-white text-center">
                                  افزودن موجودی انبار جدید
                </span>
              </button>
            </div>
          </div>
        </div>
        <section class="bg-white rounded-xl border border-gray-200 p-4 mb-3">
          <h2 class="text-sm font-semibold text-gray-800 mb-4">تنظیمات رنگ تست مجازی رژلب</h2>
          <div class="mb-3">
            <label class="block">کد رنگ تست مجازی رژلب (اختیاری)</label>
            <input v-model="form.try_on_color_hex" dir="ltr" maxlength="7" placeholder="#BE536A" class="border rounded px-3 py-2" />
            <span :style="{backgroundColor: /^#[0-9a-f]{6}$/i.test(form.try_on_color_hex) ? form.try_on_color_hex : 'transparent', display: 'inline-block', width: '28px', height: '28px', border: '1px solid #ccc', verticalAlign: 'middle'}"></span>
            <p v-if="form.try_on_color_hex && !/^#[0-9a-f]{6}$/i.test(form.try_on_color_hex)" class="text-red-600">کد رنگ باید به شکل #RRGGBB باشد.</p>
            <div class="flex flex-wrap gap-3 mt-3">
              <label class="block">شدت اولیه
                <input v-model.number="form.try_on_opacity" type="number" min="0" max="1" step="0.01" dir="ltr" class="block border rounded px-3 py-2 w-28" />
              </label>
              <label class="block">پوشانندگی
                <input v-model.number="form.try_on_coverage" type="number" min="0" max="1" step="0.01" dir="ltr" class="block border rounded px-3 py-2 w-28" />
              </label>
              <label class="block">روشنایی رنگ
                <input v-model.number="form.try_on_brightness" type="number" min="0.5" max="1.5" step="0.01" dir="ltr" class="block border rounded px-3 py-2 w-28" />
              </label>
            </div>
            <p class="text-sm text-gray-500 mt-2">تنظیم هر تنوع مستقل است. برای کالیبراسیون، نتیجه را با نمونه واقعی در نور ثابت و روی لب روشن و تیره مقایسه کنید؛ نمایش همچنان تقریبی است.</p>
          </div>
        </section>
        <div class="mb-8" v-if="form.product_type != 'variable'">
          <h2 class="text-lg font-medium text-gray-800 mb-4 border-b pb-2 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-2 text-pink-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
            جزییات
          </h2>
          <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div class="md:col-span-1">
              <label for="shelf" class="block text-sm font-medium text-gray-700 mb-1">ستون قفسه</label>
              <input
                  id="shelf"
                  v-model="form.shelf_number"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 pr-10"
              />
            </div>
            <div class="md:col-span-1">
              <label for="aisle" class="block text-sm font-medium text-gray-700 mb-1">ردیف قفسه </label>
              <input
                  id="aisle"
                  v-model="form.aisle"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 pr-10"
              />
            </div>
            <div class="md:col-span-1">
              <label for="product_date" class="block text-sm font-medium text-gray-700 mb-1">تاریخ تولید</label>
              <date-field
                  id='product_date'
                  v-model="form.product_date"
              />
            </div>
            <div class="md:col-span-1">
              <label for="expired_date" class="block text-sm font-medium text-gray-700 mb-1">تاریخ انقضا</label>
              <date-field
                  id='expired_date'
                  v-model="form.expired_date"
              />
            </div>
          </div>
        </div>
        <div class="mb-8">
          <h2 class="text-lg font-medium text-gray-800 mb-4 border-b pb-2 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-2 text-purple-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
            </svg>
            دسته‌بندی و برند
          </h2>
          <div class="grid grid-cols-1 gap-3">
            <div>
              <label for="brand" class="block text-sm font-medium text-gray-700 mb-1">برند</label>
              <brand-select scope="local" id="brand" v-model="form.brand"></brand-select>
              <p v-if="errors.brand" class="mt-1 text-sm text-red-600">{{ errors.brand }}</p>
            </div>
            <category-tree-select
                label="دسته بندی"
                v-model="form.categorization"
                :categories="categorizations"
                :errors="errors"
            />
            <category-tree-select
                label="خواص"

                v-model="form.avails"
                :categories="avails"
                :errors="errors"
            />
            <category-tree-select
                label="ویژگی"
                v-model="form.feature"
                :categories="features"
                :errors="errors"
            />
          </div>
        </div>

        <div class="mb-8" v-if="form.product_type != 'variable'">
          <h2 class="text-lg font-medium text-gray-800 mb-4 border-b pb-2 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-2 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="#00264d">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4m4-6l4-4m0 0l-4-4m4 4H8"/>
            </svg>
            اطلاعات پستی
          </h2>
          <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div>
              <label for="postal_weight" class="block text-sm font-medium text-gray-700 mb-1">وزن (گرم)</label>
              <div class="relative rounded-md shadow-sm">
                <input
                    v-model.number="form.postal_weight"
                    id="postal_weight"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 pr-10"
                    :class="{'border-red-300': errors.postal_weight}"
                >
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span class="text-gray-500 text-sm">گرم</span>
                </div>
              </div>
              <p v-if="errors.postal_weight" class="mt-1 text-sm text-red-600">{{ errors.postal_weight }}</p>
            </div>

            <div>
              <label for="length" class="block text-sm font-medium text-gray-700 mb-1">طول</label>
              <div class="relative rounded-md shadow-sm">
                <input
                    v-model.number="form.length"
                    id="length"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 pr-10"
                    :class="{'border-red-300': errors.length}"
                >
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span class="text-gray-500 text-sm">سانت</span>
                </div>
              </div>
              <p v-if="errors.length" class="mt-1 text-sm text-red-600">{{ errors.length }}</p>
            </div>

            <div>
              <label for="width" class="block text-sm font-medium text-gray-700 mb-1">عرض</label>
              <div class="relative rounded-md shadow-sm">
                <input
                    v-model.number="form.width"
                    id="width"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 pr-10"
                    :class="{'border-red-300': errors.width}"
                >
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span class="text-gray-500 text-sm">سانت</span>
                </div>
              </div>
              <p v-if="errors.width" class="mt-1 text-sm text-red-600">{{ errors.width }}</p>
            </div>

            <div>
              <label for="height" class="block text-sm font-medium text-gray-700 mb-1">ارتفاع</label>
              <div class="relative rounded-md shadow-sm">
                <input
                    v-model.number="form.height"
                    id="height"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 pr-10"
                    :class="{'border-red-300': errors.height}"
                >
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span class="text-gray-500 text-sm">سانت</span>
                </div>
              </div>
              <p v-if="errors.height" class="mt-1 text-sm text-red-600">{{ errors.height }}</p>
            </div>

          </div>
        </div>

        <div class="mt-8" v-if="form.product_type == 'variable'">
          <div class="mb-8">
            <h2 class="text-lg font-medium text-gray-800 mb-4 border-b pb-2 flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-2 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
              </svg>
              تنوع محصول
            </h2>

            <button
                v-if="!showVariationForm"
                @click="showVariationForm = true"
                type="button"
                class="mb-4 flex items-center px-4 py-2 bg-gradient-to-r from-indigo-500 to-purple-600 text-white rounded-md hover:from-indigo-600 hover:to-purple-700 transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-1" viewBox="0 0 20 20" fill="white">
                <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
              </svg>
              <span class="white--text">
                افزودن متغیر جدید
              </span>
            </button>

            <div class="bg-white rounded-lg shadow overflow-hidden">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">تصویر</th>
                  <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">نام</th>
                  <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">SKU</th>
                  <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">موجودی</th>
                  <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">قیمت</th>
                  <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">عملیات</th>
                </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="(variation, index) in form.variations" :key="index" class="hover:bg-gray-50">
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div v-if="variation.image" class="flex-shrink-0 w-10 h-10 rounded-md overflow-hidden border-2 border-gray-200">
                      <img :src="image_source(variation.image)" class="w-full h-full object-cover" alt="Variation image">
                    </div>
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ variation.name }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ variation.sixteen_digit_code }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <span :class="{
                      'bg-green-100 text-green-800': variation.calculate_current_inventory > 10,
                      'bg-yellow-100 text-yellow-800': variation.calculate_current_inventory <= 10 && variation.calculate_current_inventory > 0,
                      'bg-red-100 text-red-800': variation.calculate_current_inventory <= 0
                    }" class="px-2 py-1 text-xs font-medium rounded-full">
                      {{ variation.calculate_current_inventory > 0 ? `${variation.calculate_current_inventory} در انبار` : 'ناموجود' }}
                    </span>
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {{variation.price | toMoney}}
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <div class="flex space-x-2 space-x-reverse">
                      <button
                          @click="editVariation(variation)"
                          class="text-indigo-600 hover:text-indigo-900"
                          title="ویرایش"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </button>
                      <button
                          @click="removeVariation(variation)"
                          class="text-red-600 hover:text-red-900"
                          title="حذف"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>

              <div v-if="form.variations.length === 0" class="text-center py-8 text-gray-500">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 mx-auto text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
                </svg>
                <p class="mt-2">هنوز متغیری اضافه نشده است</p>
              </div>
            </div>
          </div>
        </div>

        <div class="flex justify-end gap-4 pb-10">
          <button
              v-if="!popUp"
              type="button"
              @click="goBack"
              class="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-200"
          >
            انصراف
          </button>
          <button
              @click="submitForm"
              class="px-4 py-2 border border-transparent rounded-md font-white text-sm font-medium bg-gradient-to-r from-blue-500 to-blue-600 items-center"
              :disabled="submitting"
          >
            <svg v-if="submitting" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span class="white--text">
              {{ id ? 'ذخیره تغییرات' : 'ایجاد محصول' }}
            </span>
          </button>
        </div>
      </form>
    </div>
    <transition name="slide-fade">
      <div v-if="showNotification"
           class="fixed bottom-4 right-4 z-50 flex items-center p-4 w-full max-w-xs text-gray-500 bg-white rounded-lg shadow-lg border border-gray-200
                  !bg-green-50 !border-green-200 !text-green-700" >

        <div class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg text-green-500 bg-green-100" >
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
          </svg>
        </div>
        <div class="mr-3 text-sm font-normal pr-2">کالا با موفقیت ثبت شد</div>
        <button @click="showNotification = false" class="mr-auto text-gray-400 hover:text-gray-900 rounded-lg p-1.5 hover:bg-gray-100">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
          </svg>
        </button>
      </div>
    </transition>
    <div v-if="showVariationForm"
         class="fixed inset-0 bg-black bg-opacity-50 z-50 overflow-hidden">
      <div class="flex items-center justify-center h-screen p-4"
           @click.self="cancelVariationEdit"
      >
        <div class="bg-white rounded-lg shadow-xl w-[95%] max-h-[90vh] overflow-y-auto">
          <admin-variation-from
              @keydown.esc="cancelVariationEdit"
              v-if="showVariationForm"
              :variation="editingVariation"
              :currency="current_currency"
              @save="handleSaveVariation"
              @cancel="cancelVariationEdit"
          />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { appendTryOnCalibration, validTryOnCalibration, tryOnCalibrationFrom } from "./tryOnCalibration";
import CategorySelect from "@/components/selects/CategorySelect";
import CategoryTreeSelect from "@/modules/product_admin/CategoryTreeSelect";
import AdminVariationFrom from "@/modules/product_admin/AdminVariationForm";
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import DateField from "@/components/mcomponents/cleave/DateField";
import StoreSelect from "@/components/selects/StoreSelect";
import BrandSelect from "@/components/selects/BrandSelect";

export default {
  name: 'AdminProductForm',
  components: {BrandSelect, StoreSelect, AdminVariationFrom, CategoryTreeSelect, CategorySelect, quillEditor, DateField},
  watch: {
    id() {
      if (this.id) {
        this.fetchProduct()
      }
      if (!this.id) {
        this.form = {
          name: '',
        try_on_color_hex: '', ...tryOnCalibrationFrom(),
          sixteen_digit_code: '',
          explanation: '',
          aisle: '',
          faq: '',
          blog: '',
          schema: '',
          faq_schema: '',
          shelf_number: '',
          inventories_in_stores: [],
          packing_inventory: {
            store: 1,
            name: 'پردازش',
            inventory: 0,
            minimum_inventory: 0
          },
          summary_explanation: '',
          how_to_use: '',
          regular_price: 0,
          price: 0,
          currency: '',
          inventory: 0,
          postal_weight: 0,
          length: 0,
          product_date: null,
          expired_date: null,
          width: 0,
          height: 0,
          status: 'draft',
          avails: [],
          categorization: [],
          feature: [],
          brand: '',
          product_type: 'simple',
          image: null,
          images: [],
          legend_pricing: 'false',
          base_price: 0,
          profit_type: 'percent',
          profit_margin: 0,
          discount_type: 'percent',
          discount_margin: 0,
          variations: []
        }
      }
    }
  },
  props: {
    id: {},
    popUp: {
      default: false
    },
  },
  data() {
    return {
      packing_inventory: {
        store: 1,
        name: 'پردازش',
        inventory: 0,
        minimum_inventory: 0
      },
      loading: false,
      submitting: false,
      errors: {},
      stores: [],
      editorOptions: {
        placeholder: 'متن خود را وارد کنید...',
        theme: 'snow',
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, 5,6,  false] }],
            ['bold', 'italic', 'underline'],
            ['link', 'image'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['clean']
          ]
        }
      },

      form: {
        name: '',
        try_on_color_hex: '', ...tryOnCalibrationFrom(),
        sixteen_digit_code: '',
        explanation: '',
        faq: '',
        blog: '',
        schema: '',
        faq_schema: '',
        summary_explanation: '',
        how_to_use: '',
        regular_price: 0,
        price: 0,
        currency: '',
        inventory: 0,
        postal_weight: 0,
        length: 0,
        product_date: null,
        expired_date: null,
        width: 0,
        height: 0,
        status: 'draft',
        content_status: 'waiting',
        categorization: [],
        feature: [],
        avails: [],
        brand: '',
        product_type: 'simple',
        image: null,
        images: [],
        legend_pricing: 'false',
        base_price: 0,
        profit_type: 'percent',
        profit_margin: 0,
        discount_type: 'percent',
        discount_margin: 0,
        variations: [],
        aisle: '',
        shelf_number: '',
        inventories_in_stores: [],
        packing_inventory: {
          store: 1,
          name: 'پردازش',
          inventory: 0,
          minimum_inventory: 0
        },
      },
      currencies: [],
      avails: [],
      features: [],
      categorizations: [],
      deletedGalleryImages: [],
      showNotification: false,
      brands: [],
      showVariationForm: false,
      editingVariation: null,
      editingIndex: -1
    }
  },
  mounted() {
    this.fetchCurrency();
    this.fetchCategories();
    this.fetchAvails();
    this.fetchFeatures();
    this.fetchBrands();
    this.getStores()

    if (this.id) {
      this.fetchProduct();
    } else {
      this.generateSKU();
    }
  },
  computed: {
    store_with_inventory_ids() {
      return this.form.inventories_in_stores.map(item => item.store);
    },
    has_new_store() {
      return this.stores.every(item => this.store_with_inventory_ids.includes(item))
    },

    current_currency() {
      if (this.form.currency) {
        return this.currencies.find(c => c.id === this.form.currency)
      }
      return {id: 0, name: 'تومان', exchange_rate_to_toman: 1}
    },
    base_price_with_rate() {
      return this.current_currency.exchange_rate_to_toman * this.form.base_price
    },
    final_amount() {
      let profitAmount = 0;
      if (this.form.profit_type == 'percent') {
        profitAmount = this.base_price_with_rate / 100 * this.form.profit_margin;
      } else {
        profitAmount = this.form.profit_margin;
      }

      let priceWithProfit = profitAmount + this.base_price_with_rate;

      let discountAmount = 0;
      if (this.form.discount_type === 'percent') {
        discountAmount = priceWithProfit / 100 * this.form.discount_margin;
      } else {
        discountAmount = this.form.discount_margin;
      }

      return priceWithProfit - discountAmount;
    },
    discount_sum() {
      let profitAmount = 0;
      if (this.form.profit_type == 'percent') {
        profitAmount = this.base_price_with_rate / 100 * this.form.profit_margin;
      } else {
        profitAmount = this.form.profit_margin;
      }

      let priceWithProfit = profitAmount + this.base_price_with_rate;

      let discountAmount = 0;
      if (this.form.discount_type === 'percent') {
        discountAmount = priceWithProfit / 100 * this.form.discount_margin;
      } else {
        discountAmount = this.form.discount_margin;
      }

      return discountAmount;
    },
    profit_sum() {
      let profitAmount = 0;
      if (this.form.profit_type == 'percent') {
        profitAmount = this.base_price_with_rate / 100 * this.form.profit_margin;
      } else {
        profitAmount = this.form.profit_margin;
      }

      return profitAmount;
    },
  },
  methods: {
    asString(v) {
      if (v == null) return ''
      if (typeof v === 'string') return v
      return ''
    },
    getStores() {
      this.request({
        url: this.endpoint(`main/store`),
        method: "get",
        success: data => {
          this.stores = []
          for (let store of data) {
            if (store.id != 1) {
              this.stores.push(store.id)
            }
          }
        }
      })
    },

    removeStore(index) {
      this.form.inventories_in_stores.splice(index, 1);
    },
    removeMainImage() {
      this.form.image = null;
    },
    reset() {
      this.id = null
      this.$router.push('/panel/adminProductForm')
    },
    removeGalleryImage(index) {
      if (this.form.images[index].id) {
        this.deletedGalleryImages.push(this.form.images[index].id);
      }
      this.form.images.splice(index, 1);
    },

    fetchProduct() {
      this.request({
        url: this.endpoint(`product/adminProductGet/${this.id}`),
        method: 'get',
        success: (response) => {
          this.form = {
            name: response.name || '',
            try_on_color_hex: response.try_on_color_hex || '', ...tryOnCalibrationFrom(response),
            sixteen_digit_code: response.sixteen_digit_code || '',
            explanation: this.asString(response.explanation),
            summary_explanation: this.asString(response.summary_explanation),
            how_to_use: this.asString(response.how_to_use),
            faq: this.asString(response.faq),
            blog: this.asString(response.blog),
            schema: this.asString(response.schema),
            faq_schema: this.asString(response.faq_schema),
            expired_date: response.expired_date || null,
            product_date: response.product_date || null,
            regular_price: response.regular_price || 0,
            price: response.price || 0,
            currency: response.currency || '',
            inventory: response.calculate_current_inventory || 0,
            postal_weight: response.postal_weight || 0,
            length: response.length || 0,
            width: response.width || 0,
            height: response.height || 0,
            status: response.status || 'draft',
            content_status: response.content_status || 'waiting',
            categorization: response.categorization || '',
            avails: response.avails || '',
            feature: response.feature || '',
            aisle: response.aisle || '',
            shelf_number: response.shelf_number || '',
            inventories_in_stores: response.inventories_in_stores || [],
            packing_inventory: response.packing_inventory,
            brand: response.brand || '',
            product_type: response.product_type || 'simple',
            image: response.picture || null,
            images: [],
            variations: response.variations || [],
            legend_pricing: 'false',
            base_price: response.base_price,
            profit_type: response.profit_type,
            profit_margin: response.profit_margin,
            discount_type: response.discount_type,
            discount_margin: response.discount_margin,

          };

          for (let item of response.gallery) {
            this.form.images.push({
              id: item.id,
              file: null,
              preview: item.picture
            })
          }
        },
      })
    },
    fetchCategories() {
      this.request({
        url: this.endpoint('product/categorizationTree'),
        method: 'get',
        success: (data) => {
          this.categorizations = data
        }
      })
    },
    fetchAvails() {
      this.request({
        url: this.endpoint('product/availsTree'),
        method: 'get',
        success: (data) => {
          this.avails = data
        }
      })
    },
    fetchFeatures() {
      this.request({
        url: this.endpoint('product/featureTree'),
        method: 'get',
        success: (data) => {
          this.features = data
        }
      })
    },

    fetchBrands() {
      this.request({
        url: this.endpoint('api/brands'),
        method: 'get',
        success: (data) => {
          this.brands = data
        }
      })
    },
    fetchCurrency() {
      this.request({
        url: this.endpoint('main/currency'),
        method: 'get',
        success: (data) => {
          this.currencies = data
        }
      })
    },
    generateSKU() {
      this.form.sixteen_digit_code = ''
    },
    addStoreInventory() {
      this.form.inventories_in_stores.push(
          {
            name: 'new',
            inventory: 0,
            store: null
          }
      )
    },
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {

        const reader = new FileReader();
        reader.onload = (e) => {
          this.form.image = {
            file: file,
            preview: e.target.result
          };
        };
        reader.readAsDataURL(file);
      }
    },
    showNotificationMessage() {
      this.showNotification = true;
      setTimeout(() => {
        this.showNotification = false;
      }, 5000);
    },

    handleGalleryUpload(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        Array.from(files).forEach(file => {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.form.images.push({
              id: null,
              file: file,
              preview: e.target.result
            });
          };
          reader.readAsDataURL(file);
        });
      }
    },

    submitForm() {
      if (!validTryOnCalibration(this.form)) {
        window.alert('شدت و پوشانندگی باید بین ۰ و ۱، و روشنایی بین ۰٫۵ و ۱٫۵ باشند.');
        return;
      }
      if (this.form.try_on_color_hex && !/^#[0-9a-f]{6}$/i.test(this.form.try_on_color_hex)) {
        window.alert('کد رنگ باید به شکل #RRGGBB باشد.');
        return;
      }

      this.submitting = true;
      this.errors = {};
      try {
        const formData = new FormData();
        const categorization_ids = this.form.categorization.map(cat => cat.id);
        const features_ids = this.form.feature.map(cat => cat.id);
        const avails_ids = this.form.avails.map(cat => cat.id);
        console.log(`${this.form.product_date || ''}`)
        formData.append('try_on_color_hex', this.form.try_on_color_hex || '');
        appendTryOnCalibration(formData, this.form);
        formData.append('name', this.form.name);
        formData.append('sixteen_digit_code', this.form.sixteen_digit_code);
        formData.append('explanation', this.form.explanation || '');
        formData.append('faq', this.form.faq || '');
        formData.append('blog', this.form.blog || '');
        formData.append('schema', this.form.schema || null);
        formData.append('faq_schema', this.form.faq_schema || null);
        formData.append('summary_explanation', this.form.summary_explanation || '');
        formData.append('how_to_use', this.form.how_to_use || '');
        formData.append('regular_price', this.form.regular_price);
        formData.append('price', this.form.price);
        formData.append('currency', this.form.currency);
        formData.append('product_date', `${this.form.product_date || ''}`);
        formData.append('expired_date', `${this.form.expired_date || ''}`);
        formData.append('calculate_current_inventory', this.form.calculate_current_inventory || 0);
        formData.append('postal_weight', this.form.postal_weight || 0);
        formData.append('length', this.form.length || 0);
        formData.append('width', this.form.width || 0);
        formData.append('height', this.form.height || 0);
        formData.append('status', this.form.status);
        formData.append('content_status', this.form.content_status);
        formData.append('product_type', this.form.product_type);
        formData.append('aisle', this.form.aisle);
        formData.append('shelf_number', this.form.shelf_number);
        formData.append('inventories_in_stores', JSON.stringify(this.form.inventories_in_stores));
        formData.append('packing_inventory', JSON.stringify(this.form.packing_inventory));
        formData.append('legend_pricing', this.form.legend_pricing);
        formData.append('base_price', this.form.base_price || 0);
        formData.append('profit_type', this.form.profit_type || 'percent');
        formData.append('profit_margin', this.form.profit_margin || 0);
        formData.append('discount_type', this.form.discount_type || 'percent');
        formData.append('discount_margin', this.form.discount_margin || 0);
        formData.append('new_inventory', this.form.inventory || 0);
        if (this.form.variations && this.form.variations.length > 0) {
          let formattedVariationsData = []
          let counter = 1
          for (let variation of this.form.variations) {
            let variationData = {
              id: variation.id || null,
              variation_title: variation.variation_title,
              name: variation.name,
              price: variation.price,
              regular_price: variation.regular_price,
              status: variation.status,
              content_status: variation.content_status,
              sixteen_digit_code: variation.sixteen_digit_code,
              length: variation.length,
              height: variation.height,
              width: variation.width,
              aisle: variation.aisle,
              shelf_number: variation.shelf_number,
              packing_inventory: JSON.stringify(variation.packing_inventory),
              inventories_in_stores: JSON.stringify(variation.inventories_in_stores),
              explanation: variation.explanation,
              summary_explanation: variation.summary_explanation,
              product_date: `${variation.product_date || ''}`,
              expired_date: `${variation.expired_date || ''}`,
              how_to_use: variation.how_to_use,
              legend_pricing: variation.legend_pricing,
              base_price: variation.base_price,
              profit_type: variation.profit_type,
              profit_margin: variation.profit_margin,
              discount_type: variation.discount_type,
              discount_margin: variation.discount_margin,
              postal_weight: variation.postal_weight,
              new_inventory: variation.calculate_current_inventory,
            }

            if (!variation.image && this.id) {
              variationData['file_key'] = 'remove';
            } else if (variation.image) {
              if (typeof variation.image === 'string') {
                variationData['file_key'] = 'same';
              } else {
                variationData['file_key'] = `var_image_${counter}`;
                formData.append(`var_image_${counter}`, variation.image.file);

              }
            }
            formattedVariationsData.push(variationData)
            counter += 1
          }
          formData.append('variations', JSON.stringify(formattedVariationsData));
        }

        categorization_ids.forEach(pk => {
          formData.append('categorization_ids', pk);
        });
        avails_ids.forEach(pk => {
          formData.append('avails_ids', pk);
        });
        features_ids.forEach(pk => {
          formData.append('features_ids', pk);
        });


        if (this.form.brand) {
          formData.append('brand', this.form.brand);
        }

        if (!this.form.image && this.id) {
          formData.append('remove_image', 'true');
        } else if (this.form.image) {
          if (this.form.image.file) {
            formData.append('image', this.form.image.file);
            formData.append('remove_image', 'false');
          } else if (typeof this.form.image === 'string') {
            formData.append('remove_image', 'false');
          }
        }

        if (this.form.images && this.form.images.length > 0) {
          this.form.images.forEach(img => {
            if (img.file) {
              formData.append('images', img.file);
            }
          });
        }

        if (this.deletedGalleryImages.length > 0) {
          this.deletedGalleryImages.forEach(pk => {
            formData.append('deleted_gallery_images', pk);
          });
        }

        const url = this.id
            ? this.endpoint(`product/adminProductUpdate/${this.id}`)
            : this.endpoint('product/adminProductCreate');

        const method = this.id ? 'put' : 'post';


        this.request({
          url,
          method,
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          success: (data) => {
            this.showNotificationMessage()
            this.id = data.id
            this.fetchProduct()
          }

        });
      } catch (error) {
        if (error.response && error.response.data) {
          this.errors = error.response.data.errors || {};
          this.$toast.error('لطفا مقادیر را بررسی کنید');
        } else {
          this.$toast.error('خطا در ذخیره اطلاعات');
          console.error('Error submitting form:', error);
        }
      } finally {
        this.submitting = false;
      }
    },
    image_source(image) {
      if (!image) return 'https://via.placeholder.com/150';
      if (/^\/media/.test(image)) return this.img_source(image)
      if (typeof image === 'string') {
        return image;
      }
      if (image.preview) {
        return image.preview;
      }
      if (image.file) {
        return URL.createObjectURL(image.file);
      }
      return 'https://via.placeholder.com/150';
    },
    goBack() {
      this.$router.push({ name: 'AdminProductList', query: { ...this.$route.query } })
    },
    handleSaveVariation(variationData) {
      if (this.editingIndex >= 0) {
        this.form.variations.splice(this.editingIndex, 1, variationData)
      } else {
        this.form.variations.push(variationData)
      }

      this.cancelVariationEdit()
    },

    editVariation(variation) {
      this.editingVariation = variation
      this.editingIndex = this.form.variations.indexOf(variation)
      this.showVariationForm = true
    },

    removeVariation(index) {
      this.form.variations.splice(index, 1)
    },

    cancelVariationEdit() {
      this.showVariationForm = false
      this.editingVariation = null
      this.editingIndex = -1
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    }

  }
}
</script>

<style scoped>
[type='text'], [type='number'], [type='email'], [type='url'], [type='password'], [type='search'],
[type='tel'], [type='file'], select, textarea {
  text-align: right;
  direction: rtl;
}
.bg-white {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
}

.border-gray-300 {
  border-color: rgba(209, 213, 219, 0.5);
}

input:not([type="radio"]),
select,
textarea {
  background-color: rgba(249, 250, 251, 0.8);
  border: 1px solid rgba(209, 213, 219, 0.6);
  box-shadow:
      inset 0 1px 2px rgba(0, 0, 0, 0.05),
      0 2px 4px rgba(0, 0, 0, 0.02);
  transition: all 0.3s ease;
  padding: 0.65rem 1rem;
  border-radius: 8px;
}

input:not([type="radio"]):focus,
select:focus,
textarea:focus {
  border-color: #3b82f6;
  box-shadow:
      0 0 0 3px rgba(59, 130, 246, 0.2),
      inset 0 1px 2px rgba(0, 0, 0, 0.05);
  background-color: white;
  outline: none;
}

label {
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
  display: block;
}

input[type="radio"] {
  width: 1.2em;
  height: 1.2em;
  border: 2px solid #d1d5db;
  transition: all 0.2s ease;
}

input[type="radio"]:checked {
  border-color: #3b82f6;
  background-color: #3b82f6;
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='8' cy='8' r='3'/%3e%3c/svg%3e");
}

.border-dashed {
  border: 2px dashed rgba(59, 130, 246, 0.4);
  background-color: rgba(239, 246, 255, 0.5);
  transition: all 0.3s ease;
}

.border-dashed:hover {
  border-color: rgba(59, 130, 246, 0.7);
  background-color: rgba(239, 246, 255, 0.8);
}

button[type="submit"] {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  box-shadow:
      0 4px 6px -1px rgba(59, 130, 246, 0.3),
      0 2px 4px -1px rgba(59, 130, 246, 0.2);
  position: relative;
  overflow: hidden;
}

button[type="submit"]:hover {
  transform: translateY(-1px);
  box-shadow:
      0 10px 15px -3px rgba(59, 130, 246, 0.3),
      0 4px 6px -2px rgba(59, 130, 246, 0.2);
}

button[type="submit"]:active {
  transform: translateY(0);
}

button[type="submit"]::after {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
      to bottom right,
      rgba(255, 255, 255, 0.3),
      rgba(255, 255, 255, 0)
  );
  transform: rotate(30deg);
  transition: all 0.3s ease;
}

button[type="submit"]:hover::after {
  left: 100%;
}

.border-red-300 {
  border-color: #fca5a5;
}

.text-red-600 {
  color: #dc2626;
}

img {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

img:hover {
  transform: scale(1.02);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

h2 {
  position: relative;
  padding-left: 1.5rem;
}

h2:before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 70%;
  width: 4px;
  background: linear-gradient(to bottom, #3b82f6, #2563eb);
  border-radius: 2px;
}

.relative .text-gray-500 {
  color: #6b7280;
  font-weight: 500;
}

button[type="button"][title="تولید خودکار"] {
  background: rgba(243, 244, 246, 0.8);
  border: 1px solid rgba(209, 213, 219, 0.6);
  transition: all 0.2s ease;
}

button[type="button"][title="تولید خودکار"]:hover {
  background: rgba(229, 231, 235, 0.8);
}
.variation-card {
  transition: all 0.3s ease;
}

.variation-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.delete-btn {
  transition: all 0.2s ease;
  color: #de4444;

}
.delete-btn:hover {
  color: #ef4444;
  transform: scale(1.1);
}

@media (max-width: 768px) {
  input:not([type="radio"]),
  select,
  textarea {
    padding: 0.75rem;
  }
}
</style>